import GeneralCalculationObject from './general-calculation.object';
import generalCalculationDefaultOptions from './defaultOptions';

export {
  GeneralCalculationObject,
  generalCalculationDefaultOptions
};



// WEBPACK FOOTER //
// ./src/object-view/generators/general-calculation/index.js